var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCircleLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 -8.30516e-07C29.4934 -1.2892e-06 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 -3.71835e-07 29.4934 -8.30516e-07 19C-1.2892e-06 8.50659 8.50659 -3.71835e-07 19 -8.30516e-07ZM19 35.15C27.9194 35.15 35.15 27.9194 35.15 19C35.15 10.0806 27.9194 2.85 19 2.85C10.0806 2.85 2.85 10.0806 2.85 19C2.85 27.9194 10.0806 35.15 19 35.15Z",
    fill: "#E0DDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 25.75H15.25C14.4212 25.75 13.75 25.0788 13.75 24.25V18.25C13.75 17.4212 14.4212 16.75 15.25 16.75H22.75C23.5788 16.75 24.25 17.4212 24.25 18.25V24.25C24.25 25.0788 23.5788 25.75 22.75 25.75Z",
    stroke: "#7265AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.8175V20.875",
    stroke: "#7265AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3977 19.9148C19.6174 20.1344 19.6174 20.4906 19.3977 20.7102C19.1781 20.9299 18.8219 20.9299 18.6023 20.7102C18.3826 20.4906 18.3826 20.1344 18.6023 19.9148C18.8219 19.6951 19.1781 19.6951 19.3977 19.9148",
    stroke: "#7265AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.75V15.25V15.25C16 13.5932 17.3432 12.25 19 12.25V12.25C20.6568 12.25 22 13.5932 22 15.25V15.25V16.75",
    stroke: "#7265AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCircleLock);
export default __webpack_public_path__ + "static/media/ProgressCircleLock.927f8bbbabe3fbad820d7d0d3fa2c804.svg";
export { ForwardRef as ReactComponent };